



























import { Component, Vue } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';

@Component
export default class OrdersListHead extends Vue {
  get isCompact() {
    return this.$vuetify.breakpoint.mdAndDown;
  }   
}
